import { useState } from "react";
import { motion } from "framer-motion";
import { TABS } from "@/data";

const ALBUM_URL = "https://ffm.to/bless-us-all";

export default function Landing({ onSelect }) {
  const [glint, setGlint] = useState(0);
  const [hasVideo, setHasVideo] = useState(true);

  return (
    <section data-testid="landing" className="flex-1 flex flex-col items-center min-h-screen">
      <div data-testid="cover-video-wrap" className="relative w-full h-[100svh] overflow-hidden bg-black">
        {hasVideo ? (
          <video data-testid="cover-video" className="absolute inset-0 w-full h-full object-cover" src="/assets/cover.mp4" poster="/assets/cover-poster.jpg"
            autoPlay muted loop playsInline onError={() => setHasVideo(false)} />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center px-6">
            <img src="/assets/bless-us-all.png" alt="Bless Us All" data-testid="landing-logo" className="w-full max-w-[560px] select-none pointer-events-none" />
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 h-[45%] bg-gradient-to-b from-transparent via-black/70 to-black pointer-events-none" />
      </div>

      <motion.a href={ALBUM_URL} target="_blank" rel="noopener noreferrer" data-testid="listen-now-link" aria-label="Listen Now on Spotify"
        initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3, duration: 0.8 }}
        onMouseEnter={() => setGlint((g) => g + 1)}
        className="glint-wrap -mt-24 sm:-mt-32 relative z-10 w-[240px] sm:w-[320px] transition-transform duration-300 hover:scale-[1.03]"
        style={{ "--glint-mask": "url(/assets/listen-now-mask.png)" }}>
        <img src="/assets/listen-now.png" alt="Listen Now" className="w-full select-none" />
        <span key={glint} className="glint" />
      </motion.a>

      <nav className="mt-12 sm:mt-16 flex flex-col items-center gap-10 sm:gap-14">
        {TABS.map((t, i) => (
          <motion.button key={t} onClick={() => onSelect(t)} data-testid={`landing-link-${t.toLowerCase()}`}
            initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.45 + i * 0.12, duration: 0.6 }}
            className="text-[#c9ccd1] hover:text-white text-3xl sm:text-4xl tracking-[0.12em] font-light transition-colors duration-300">
            {t}
          </motion.button>
        ))}
      </nav>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1, duration: 0.8 }}
        className="w-full max-w-3xl px-4 sm:px-8 mt-20 sm:mt-28 pb-20" data-testid="landing-video-feature">
        <div className="relative w-full aspect-video bg-[#0a0a0a]">
          <iframe data-testid="landing-video-player" title="XO Vasco - BUA WORLD (Official Music Video)" className="absolute inset-0 w-full h-full"
            src="https://www.youtube.com/embed/AOHO6bCBA3I?rel=0&modestbranding=1" frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen loading="lazy" />
        </div>
        <p className="mt-3 text-[#8a8e95] text-sm sm:text-base tracking-[0.2em]">BUA WORLD</p>
      </motion.div>
    </section>
  );
}
